/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should a slug use hyphens or underscores?`)
};

const es_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Debería un slug usar guiones o guiones bajos?`)
};

const de_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollte ein Slug Bindestriche oder Unterstriche verwenden?`)
};

const nl_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moet een slug koppeltekens of onderstrepingstekens gebruiken?`)
};

const fr_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un slug doit-il utiliser des tirets ou des tirets bas ?`)
};

const it_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno slug dovrebbe usare trattini o trattini bassi?`)
};

const pt_br2_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um slug deve usar hífens ou sublinhados?`)
};

const pt_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um slug deve usar hífens ou sublinhados?`)
};

const ja_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スラグはハイフンとアンダースコアのどちらを使うべきですか?`)
};

const zh_sg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slug 应该使用连字符还是下划线？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_faq4_q", locale)
	if (locale === "en") return en_sg_faq4_q(inputs)
	if (locale === "es") return es_sg_faq4_q(inputs)
	if (locale === "de") return de_sg_faq4_q(inputs)
	if (locale === "nl") return nl_sg_faq4_q(inputs)
	if (locale === "fr") return fr_sg_faq4_q(inputs)
	if (locale === "it") return it_sg_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_sg_faq4_q(inputs)
	if (locale === "pt") return pt_sg_faq4_q(inputs)
	if (locale === "ja") return ja_sg_faq4_q(inputs)
	return zh_sg_faq4_q(inputs)
};